<!-- filepath: src/components/shared/ParticipationDaysShort.vue -->
<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on" class="cursor-pointer">
          <span
            v-for="(id, idx) in parsedDays"
            :key="id"
          >
            {{ getDayOfWeek(id) }}{{ getFacilityShort(id) }}
            <span v-if="idx < parsedDays.length - 1">, </span>
          </span>
        </span>
      </template>
      <span>
        <span
          v-for="id in parsedDays"
          :key="id"
        >
          <div v-if="getWorkoutScheduleById(id)">
            {{ workoutScheduleLabel(getWorkoutScheduleById(id)) }}
          </div>
        </span>
      </span>
    </v-tooltip>
  </div>
</template>

<script>
import { getWorkoutScheduleById } from "../../_helpers/index";

export default {
  name: "ParticipationDaysShort",
  props: {
    participationDays: { type: [Array, String], default: null },
    workoutSchedules: { type: Array, required: true },
    workoutScheduleLabel: { type: Function, required: true }
  },
  computed: {
    parsedDays() {
      if (!this.participationDays) return [];
      if (typeof this.participationDays === "string") {
        try {
          const parsed = JSON.parse(this.participationDays);
          return Array.isArray(parsed) ? parsed : [];
        } catch {
          return [];
        }
      }
      return Array.isArray(this.participationDays) ? this.participationDays : [];
    }
  },
  methods: {
    getDayOfWeek(id) {
      const ws = this.getWorkoutScheduleById(id);
      return ws && ws.dayOfWeek ? ws.dayOfWeek : "?";
    },
    getFacilityShort(id) {
      const ws = this.getWorkoutScheduleById(id);
      if (ws && ws.facility && ws.facility.name) {
        return `(${ws.facility.name.substring(0, 7)})`;
      }
      return "";
    },
    getWorkoutScheduleById
  }
};
</script>